var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "upload (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cosmetic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-1-Profile-Copy-9",
    transform: "translate(-1154.000000, -115.000000)",
    fill: "#3FAE29",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-(1)",
    transform: "translate(1166.000000, 128.000000) scale(1, -1) rotate(-180.000000) translate(-1166.000000, -128.000000) translate(1154.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7986928,6.95166667 L13.1111514,0.285 C12.9567753,0.105 12.7341487,0 12.500147,0 C12.2661453,0 12.0435186,0.105 11.8891425,0.285 L6.20160109,6.95166667 C5.99197457,7.19833333 5.93997419,7.54666667 6.07322516,7.845 C6.20485112,8.14166667 6.49410323,8.33333333 6.81260554,8.33333333 L10.0626292,8.33333333 L10.0626292,19.1666667 C10.0626292,19.6266667 10.4266319,20 10.8751351,20 L14.1251588,20 C14.5736621,20 14.9376647,19.6266667 14.9376647,19.1666667 L14.9376647,8.33333333 L18.1876884,8.33333333 C18.5061907,8.33333333 18.7954428,8.14333333 18.9270688,7.845 C19.0586947,7.54666667 19.0099444,7.19666667 18.7986928,6.95166667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8,18 L20.8,22.8 L3.2,22.8 L3.2,18 L0,18 L0,24.4 C0,25.2848 0.7168,26 1.6,26 L22.4,26 C23.2848,26 24,25.2848 24,24.4 L24,18 L20.8,18 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.bafee9af32e661ba419bdd5026f415a5.svg";
export { ForwardRef as ReactComponent };